import React, { useContext } from "react";
import "./App.css";
import { Layout, Menu, Icon } from "antd";
import "antd/dist/antd.css";
import { Route, Link, withRouter, Switch, Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import { AuthDataContext } from "./Components/Auth/SelfHostedAuth";
import * as nameUtils from "./Common/Utils";

import domusoLogo from "./assets/domuso-logo.png";
import Spinner from "./Components/Spinner/Spinner";

const { Content, Footer, Sider } = Layout;

// CODE SPLITTING
const Reservations = Loadable({
  loader: () => import("./Pages/Reservations/Reservations"),
  loading: Spinner
});

const BlacklistReservations = Loadable({
  loader: () => import("./Pages/BlacklistReservations/BlacklistReservations"),
  loading: Spinner
});

const FundsManagement = Loadable({
  loader: () => import("./Pages/FundsManagement/FundsManagement"),
  loading: Spinner
});

const Onboarding = Loadable({
  loader: () => import("./Pages/Onboarding/Onboarding"),
  loading: Spinner
});

const Home = Loadable({
  loader: () => import("./Pages/Home/Home"),
  loading: Spinner
});

const SignOut = Loadable({
  loader: () => import("./Pages/SignOut/SignOut"),
  loading: Spinner
});

function App(props) {
  const AuthData = useContext(AuthDataContext);

  if (!AuthData.attributes) {
    return null;
  }

  const routes = [
    {
      path: "/fundsManagement",
      icon: "thunderbolt",
      text: "Funds Management",
      component: FundsManagement
    },
    {
      path: "/blacklistReservations",
      icon: "stop",
      text: "Blacklist",
      component: BlacklistReservations
    },
    {
      path: "/onboarding",
      icon: "bank",
      text: "Onboarding",
      component: Onboarding
    },
    {
      path: "/Reservations",
      icon: "user",
      text: "Reservations",
      component: Reservations
    }
  ];

  const handleSidebarClick = ({ key }) => {
    props.history.push(key);
  };

  const handleSignout = async e => {
    e.preventDefault();
    e.stopPropagation();
    props.history.push("/signout");
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider collapsible>
        <div className="logo">
          <Link to="/">
            <img src={domusoLogo} className="App-logo" alt="domuso-logo" />
          </Link>
        </div>
        <h4 style={{ color: "white", textAlign: "center", fontStyle: "italic" }}>
          {nameUtils.emailToFirstName(AuthData.attributes.email)}
        </h4>
        <Menu theme="dark" mode="inline" defaultSelectedKeys={["0"]} onClick={handleSidebarClick}>
          {routes.map(item => (
            <Menu.Item key={item.path}>
              <Icon type={item.icon} />
              <span>{item.text}</span>
            </Menu.Item>
          ))}

          <Menu.Item key="signout" style={{ position: "fixed", bottom: 50, width: 200 }}>
            <Icon type="logout" />
            <span onClick={handleSignout}>SIGN OUT</span>
          </Menu.Item>
        </Menu>
      </Sider>

      <Layout>
        <Content style={{ margin: "24px 16px", padding: 24, background: "#fff", minHeight: 280 }}>
          <Switch>
            {routes.map(item => (
              <Route key={item.path} path={item.path} component={item.component} />
            ))}
            <Route key={"/signout"} path={"/signout"} component={SignOut} exact />
            <Route key={"/"} path={"/"} component={Home} exact />
            <Redirect to="/" />
          </Switch>
        </Content>

        <Footer
          style={{
            marginTop: "-24px",
            textAlign: "center",
            padding: "10px"
          }}
        >
          Domuso ©2021
        </Footer>
      </Layout>
    </Layout>
  );
}

export default withRouter(App);
